export default {
      id: "photo-usage",
      viewBox: "0 0 15 11",
      url: __webpack_public_path__ + "img/icons.svg#photo",
      toString: function () {
        return this.url;
      }
    }